const API = {
  //助力
  helpAddPoints: "/biz/operation-activity/treasure/help",
  // 获取当前积分状态及受助情况
  getMyStatus: "/biz/operation-activity/treasure/help/record/get",
  // 打开宝箱
  openTreasure: "/biz/operation-activity/treasure/open",
  // 抢宝物
  grabTreasure: "/biz/operation-activity/treasure/seckill",
  // 获取宝物库存
  getStorage: "/biz/operation-activity/treasure/stock/status/get",
  // 奖品
  getMyGift: "/biz/operation-activity/activity/gifts",
}

export default API
